import PlacementList from "./PlacementList";

export default PlacementList;
